import { Bar } from 'react-chartjs-2';
import styles from 'styles/components/pages/common/BarChart.module.scss';
import classNames from 'classnames';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { getScoreColor } from 'utils/score';
import { TScoreByChart } from 'types/chart';

type TProps = {
  type: string;
  data: TScoreByChart[];
};

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      align: 'top' as const,
      anchor: 'end' as const,
      font: {
        size: 14,
      },
    },
    annotation: {
      annotations: [
        {
          mode: 'horizontal',
          scaleID: 'y',
          value: 50, // 가로선을 그릴 위치
          borderColor: STYLES_VARIABLES.GRAY_04,
          borderWidth: 1,
        },
      ],
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        font: {
          weight: 'bold',
        },
      },
    },
    y: {
      max: 110, // Y축 최대값 설정
      min: 0, // Y축 최소값 설정
      ticks: {
        stepSize: 50,
        callback: (value: any) => {
          // 눈금 렌더링 콜백 함수
          if (value === 0 || value === 50 || value === 100) {
            return value.toString(); // 0, 50, 100 눈금만 보이도록 설정
          }
          return '';
        },
      },
      grid: {
        display: true,
        color: STYLES_VARIABLES.GRAY_05,
        borderWidth: 1,
        drawBorder: false,
        drawOnChartArea: false,
        drawTicks: false,
      },
    },
  },
};

const BarChart = ({ type, data }: TProps) => {
  const barData = {
    labels: data.map((item) => item.chartName),
    datasets: [
      {
        label: '',
        data: data.map((item) => item.score),
        backgroundColor: data.map(
          (item) => STYLES_VARIABLES[getScoreColor(item.score)]
        ),
        barThickness: 40,
        borderRadius: 8,
        datalabels: {
          color: data.map(
            (item) => STYLES_VARIABLES[getScoreColor(item.score)]
          ),
        },
      },
    ],
  };

  return (
    <div
      className={classNames(styles.section, {
        [styles.section_border]: type === 'student',
      })}
    >
      <div className={styles.title_wrapper}>
        {type === 'student' ? (
          <h2 className={styles.title}>차트별 평가 그래프</h2>
        ) : (
          <>
            <h2 className={styles.title}>차트별 평균 점수</h2>
            <span className={styles.text}> 단위 : (점)</span>
          </>
        )}
      </div>
      <Bar width={970} height={338} data={barData} options={options} />
    </div>
  );
};

export default BarChart;
